import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmButton = ({
    className = "",
    title = "Delete",
    label = "Confirm",
    danger = true,
    action = () => { },
    data = null,
    redirect = null,
    template = null,
    message = "Are you sure you want to proceed? This action cannot be undone.",
}) => {
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();

    const confirmAction = async () => {
        setShowModal(false);
        if (action) {
            const callback = await action(data)?.then((result) => {
                if (redirect) {
                    navigate(redirect)
                }
                return result;
            });
            return callback;
        }
    };

    const ConfirmationModal = ({ show, onAccept, onCancel }) => {
        if (!show) return null;

        return (
            <div className="modal fade show position-static d-block w-auto h-auto overflow-visible confirmButtonModal" tabIndex="-1" id="deleteChat">
                <div className="modal-dialog modal-dialog-centered modal-sm my-0">
                    <div className="modal-content border-0">
                        <div className="modal-body">
                            <div className="py-4 px-4 text-center">
                                <h3 className="text-capitalize">{title}</h3>
                                <p className="small">{message}</p>
                                <ul className="tyn-list-inline gap gap-3 pt-1 justify-content-center">
                                    <li>
                                        <button className="btn btn-danger" onClick={onAccept} data-bs-dismiss="modal">
                                            Confirm
                                        </button>
                                    </li>
                                    <li>
                                        <button className="btn btn-light px-4" onClick={onCancel} data-bs-dismiss="modal">
                                            No
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {template ? (
                <span onClick={() => setShowModal(true)}>{template}</span>
            ) : (
                <button
                    className={`tf-btn btn-md text-capitalize ${danger ? "btn-danger" : "btn-primary"} ${className}`}
                    onClick={() => setShowModal(true)}
                >
                    {label}
                </button>
            )}


            <ConfirmationModal
                show={showModal}
                onAccept={confirmAction}
                onCancel={() => setShowModal(false)}
            />
        </>
    );
};

export default ConfirmButton;
